import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { GetCountryDocuments } from '../services/get-country-documents';
import { IExternalCountryItem } from '../models/external-country.model';

export const countriesResolver: ResolveFn<IExternalCountryItem[]> = async () => {
    const getCountryDocsService = inject(GetCountryDocuments);
    return await getCountryDocsService.getAllExternalCountries();
};
